var render, staticRenderFns
import script from "./rule_modal.vue?vue&type=script&lang=js"
export * from "./rule_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10aec039')) {
      api.createRecord('10aec039', component.options)
    } else {
      api.reload('10aec039', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_rule/components/rule_modal/rule_modal.vue"
export default component.exports